<template>
  <!-- 次级折叠面板 -->
  <el-collapse class="sub-collapse padding_0" :value="1">
    <el-collapse-item :name="1" :title="title">
      <template v-for="(item, index) in settings">
        <basic-setting
          class="basic-item"
          v-if="typeof item == 'string' || (item.type === 'basic' && enable(item))"
          :config="typeof item == 'string' ? item : item.name"
        />
        <block-setting v-else-if="item.type === 'block' && enable(item)" :settings="item.settings" :title="item.title" :tips="item.tips" />
      </template>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
import basicSetting from "./basic-setting.vue"
import blockSetting from "./block-setting.vue";
export default {
  inject: ['configData', 'configs', 'mergedConfigData'],
  components: {
    basicSetting,
    blockSetting
  },
  props: {
    settings: Array,
    title: String,
    tips: [String, Object]
  },
  computed: {
    enable() {
      return (config) => {
        if (config?.enable) {
          return config.enable(this.mergedBasicConfigData)
        }
        return true
      }
    },
    basicConfigData() {
      return this.configData()
    },
    mergedBasicConfigData() {
      return this.mergedConfigData()
    }
  }
}
</script>
<style scoped lang="scss">
.basic-item:not(:last-child) {
  margin-bottom: 12px;
}
::v-deep.sub-collapse .el-collapse-item__content {
  padding: 0 0px 0 18px !important;
}
::v-deep.sub-collapse .el-collapse-item__header {
  background: var(--elCollapseItemWrapBgColor) !important;
  font-weight: 400 !important;
  padding: 0 12px 0 18px  !important;
}
::v-deep.sub-collapse .el-collapse-item__header .el-collapse-item__arrow {
  left: 0 !important;
}
</style>